export const ProjectsData = [
  {
    id: 8,
    name: "Nadmorscy Biegacze",
    mainImage: require("../Images/Projects/NadmorscyBiegacze/1.jpg"),
    images: [
      require("../Images/Projects/NadmorscyBiegacze/1.jpg"),
      require("../Images/Projects/NadmorscyBiegacze/2.jpg"),
    ],
    contentTitle:
      "This website is buit for the running association in Kołobrzeg town. The primary goal of the assoctiation is to advocate for running as a lifestyle choice and inspire individuals to engage in physical activity",
    content: ["This project is built whith NextJS"],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "Logo design",
      item3: "CSS styling using modules",
      item4: "Mobile and desktop responsiveness via CSS Media queries",
      item5: "This project is using NextJS server components",
      item6: "Read URL params and display news post and categories by slug",
      item7: "Pagination for posts with limit to 6 per page",
    },

    links: [
      {
        name: "Nadmorscy Biegacze page",
        link: "https://nadmorscy-biegacze.pl/",
      },
    ],
  },
  {
    id: 1,
    name: "Kołobrzeski Bieg Zaślubin",
    mainImage: require("../Images/Projects/KolobrzeskiBieg/strona.jpg"),
    images: [
      require("../Images/Projects/KolobrzeskiBieg/strona.jpg"),
      // require("../Images/Projects/KolobrzeskiBieg/strona.jpg"),
      // require("../Images/Projects/KolobrzeskiBieg/strona.jpg"),
    ],
    contentTitle:
      "Website built for Town Council of Kołobrzeg to promote a running event that is held in town since 1987.",
    content: ["This project is built whith NextJS"],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "CSS styling using modules",
      item3: "Mobile and desktop responsiveness via CSS Media queries",
      item4: "This project is using NextJS server components",
      item5: "Read URL params and display blog post and categories by slug",
      item6: "Added pagination for posts with limit to 6 per page",
    },

    links: [
      {
        name: "Kołobrzeski Bieg Zaślubin page",
        link: "https://kolobrzeski-bieg.pl/",
      },
    ],
  },
  {
    id: 2,
    name: "Blog and White",
    mainImage: require("../Images/Projects/BlogWhite/blogwhite2.jpg"),
    images: [
      require("../Images/Projects/BlogWhite/blogwhite1.jpg"),
      require("../Images/Projects/BlogWhite/blogwhite2.jpg"),
      require("../Images/Projects/BlogWhite/blogwhite3.jpg"),
    ],
    contentTitle:
      "Blog platform that's using Hygraph CMS for content managment.",
    content: [
      "Post your Blogs with ease using Hygraph Content Managment System.",

      "This project is built whith NextJS and Hygraph CMS.",
    ],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "CSS styling using modules",
      item3: "Mobile and desktop responsiveness via CSS Media queries",
      item4: "This project is using NextJS server components",
      item5:
        "Implemented different API fetch methods for all posts , posts categories , single post etc..",
      item6: "Read URL params and display blog post and categories by slug",
      item7: "Added pagination for posts with limit to 30 per page",
    },

    links: [
      {
        name: "Blog and White Live page",
        link: "https://thatsblogs.vercel.app/",
      },
    ],
  },
  {
    id: 3,
    name: "Comptrends",
    mainImage: require("../Images/Projects/Comptrends/comptrends1.jpg"),
    images: [
      require("../Images/Projects/Comptrends/comptrends2.jpg"),
      require("../Images/Projects/Comptrends/comptrends1.jpg"),
      require("../Images/Projects/Comptrends/comptrends3.jpg"),
    ],
    contentTitle:
      "Website built for a company that provides webscraping data solutions.",
    content: [
      "Comptrends delivers data for your business.",
      "By staying informed on the latest trends and changes in your industry, you'll be able to make smarter decisions and stay competitive.",
      "This website is built whith NextJS and Redux Toolkit.",
    ],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "CSS styling using modules",
      item3: "Mobile and desktop responsiveness via CSS Media queries",
      item4: "Animations built with FramerMotion",
      item5: "react-intersection-observer used for left scroll-menu",
      item6: "Redux Toolkit used for state managment",
      item7: "EmailJs used for contact form",
    },

    links: [
      {
        name: "Comptrends.eu Live page",
        link: "https://comptrendseu.netlify.app/",
      },
    ],
  },
  {
    id: 4,
    name: "Rezon Catalogue",
    mainImage: require("../Images/Projects/Rezon/rezon1.jpg"),
    images: [
      require("../Images/Projects/Rezon/rezon2.jpg"),
      require("../Images/Projects/Rezon/rezon1.jpg"),
      require("../Images/Projects/Rezon/rezon3.jpg"),
    ],
    contentTitle: "Online product catalogue for Rezon.eu",
    content: [
      "Product catalouge with 280+ products and 17 categories for a company that produces gifts and souvenirs.",

      "Online catalogue used by sales team to showcase products to potential clients.",
      "Main requirement for this project was to be mobile responsive with categories and ability to search for a product.",
    ],
    listTitle: "Features implemented :",
    list: {
      item1: "Design for desktop and mobile screens",
      item2: "CSS styling using modules",
      item3: "Mobile and desktop responsiveness via CSS Media queries",
      item4: "Slider and mini slider built to showcase product images",
      item5: "Search bar to search product by name or code",
      item6: "Redux Toolkit used for state managment",
      item7: "Local storage used to add products to favourites",
      item9:
        "Modal component to display product details with storage levels image etc...",
      item8: "EmailJs used for contact form",
    },

    links: [
      {
        name: "Rezon.eu Catalogue Live page",
        link: "https://rezon-katalog.netlify.app/",
      },
    ],
  },
  {
    id: 5,
    name: "Hearthstone Battlegrounds",
    mainImage: require("../Images/Projects/Hearthstone/intro.jpg"),
    images: [
      require("../Images/Projects/Hearthstone/1.jpg"),
      require("../Images/Projects/Hearthstone/2.jpg"),
      require("../Images/Projects/Hearthstone/3.jpg"),
    ],
    contentTitle: "Browse and learn Hearthstone Battlegrounds cards",
    content: [
      "This project is using Hearthstone API.",

      "This project is built in React and is using Redux toolkit as state managment.",
    ],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "CSS styling",
      item3: "Mobile and desktop responsive via CSS Media queries",
      item4: "Display Loading component when app is loading",
      item5: "Add and remove cards from favorites",
      item6: "Filter options for cards",
      item7:
        "Ability to move to next page , previous page , last page and first page",
      item8: "Local storage to keep favorite cards saved",
    },

    links: [
      {
        name: "Hearthstone Battlegrounds app Live",
        link: "https://hs-battlegrounds.netlify.app/",
      },
    ],
  },
  {
    id: 6,
    name: "Project Gutenberg App",
    mainImage: require("../Images/Projects/Gutenberg/intro.jpg"),
    images: [
      require("../Images/Projects/Gutenberg/1.jpg"),
      require("../Images/Projects/Gutenberg/2.jpg"),
      require("../Images/Projects/Gutenberg/3.jpg"),
    ],
    contentTitle: "Project Gutenberg is an application to browse free E-books",
    content: [
      "This project is using Project Gutenberg API a RESTful API to access the entire Project Gutenberg catalogue.",

      "This project is built in ReactJS.",
    ],
    listTitle: "Features implemented :",
    list: {
      item1: "Figma design for desktop and mobile screens",
      item2: "CSS styling",
      item3: "Mobile and desktop responsive via CSS Media queries",
      item4: "Search bar to search for books",
      item5: "Add and remove books from favorites",
      item6: "Filter books by language",
      item7:
        "Ability to move to next page , previous page , last page and first page",
      item8: "Local storage to keep favorite books saved",
    },

    links: [
      {
        name: "Project Gutenberg app Live",
        link: "https://gutenberg-app.netlify.app",
      },
    ],
  },
  // {
  //   id: 3,
  //   name: "Shipmodels",
  //   mainImage: require("../Images/Projects/Shipmodels/shipintro.jpg"),
  //   images: [
  //     require("../Images/Projects/Shipmodels/ship1.jpg"),
  //     require("../Images/Projects/Shipmodels/ship2.jpg"),
  //     require("../Images/Projects/Shipmodels/ship3.jpg"),
  //     require("../Images/Projects/Shipmodels/ship4.jpg"),
  //     require("../Images/Projects/Shipmodels/ship5.jpg"),
  //   ],
  //   contentTitle:
  //     "Shipmodels is a company that specializes in building quality and detailed models of ships .",
  //   content: [
  //     "The current company website had to be re-designed and built from scratch . Website has to be mobile friendly end SEO optimized. This project was done together with my brother Grzegorz Zygan .",

  //     "I was doing Frontend development and Graphic Design . The whole Backend was done by Grzegorz Zygan.",
  //   ],
  //   listTitle: "Features implemented :",
  //   list: {
  //     item1: "Figma design for desktop and mobile screens",
  //     item2: "Website built in Html",
  //     item3: "CSS styling",
  //     item4: "Mobile and desktop responsive via CSS Media queries",
  //     item5: "Mobile navbar (hamburger menu) JS",
  //     item6: "Modal JS",
  //     item7: "Image Slider JS",
  //     item8: "Back to home button JS",
  //     item9: "Dynamic date set in footer JS",
  //   },

  //   links: [
  //     {
  //       name: "GitHub Case Study",
  //       link: "https://github.com/sbtah/shipmodels-django-site",
  //     },
  //   ],
  // },

  // {
  //   id: 4,
  //   name: "Rebelinska Art",
  //   mainImage: require("../Images/Projects/AR art/arintro.jpg"),
  //   images: [
  //     require("../Images/Projects/AR art/ar1.jpg"),
  //     require("../Images/Projects/AR art/ar2.jpg"),
  //     require("../Images/Projects/AR art/ar3.jpg"),
  //     require("../Images/Projects/AR art/ar4.jpg"),
  //   ],
  //   contentTitle:
  //     "Rebelinska Art is a portfolio website designed to showcase the client recent work .",
  //   content: [
  //     "I wanted to keep a simple and elegant look for the website to fit the art theme of this project.",
  //     "The website is built in responsive technology.",
  //     "First I've designed the website in Figma , and later on the design was approved by client.",
  //     "Website was build in HTML , CSS and JavaScript.",
  //   ],
  //   listTitle: "Features implemented :",
  //   list: {
  //     item1: "Figma design for desktop and mobile screens",
  //     item2: "Website built in Html",
  //     item3: "CSS styling",
  //     item4: "Mobile and desktop responsive via CSS Media queries",
  //     item5: "Mobile navbar (hamburger menu) JS",
  //     item6: "Back to home button JS",
  //     item7: "Dynamic date set in footer JS",
  //   },
  //   links: [
  //     {
  //       name: "View live Demo",
  //       link: "https://portfoliomzdesign.netlify.app",
  //     },
  //   ],
  // },
  {
    id: 7,
    name: "Graphic Design",
    mainImage: require("../Images/Projects/Graphic Design/graphicintro.jpg"),
    images: [
      require("../Images/Projects/Graphic Design/1.jpg"),
      require("../Images/Projects/Graphic Design/2.jpg"),
      require("../Images/Projects/Graphic Design/3.jpg"),
      require("../Images/Projects/Graphic Design/4.jpg"),
      require("../Images/Projects/Graphic Design/5.jpg"),
    ],
    contentTitle:
      "I am aiming to create the best designs while keeping things simple.",
    content: [
      "My favorite graphic design style is Minimalism.",
      "Most of my work I've done using the principles of minimalist graphic design.",
      "I am always trying to keep up too date with all the graphic design trends.",
      "You can find more of my graphic designs on my Behance profile. ",
    ],
    links: [{ name: "Here", link: "https://www.behance.net/marcin-zygan" }],
  },
  {
    id: 8,
    name: "Github Projects",
    mainImage: require("../Images/Projects/Github/githubintro.jpg"),
    images: [
      require("../Images/Projects/Github/1.jpg"),
      require("../Images/Projects/Github/2.jpg"),
      require("../Images/Projects/Github/3.jpg"),
      require("../Images/Projects/Github/4.jpg"),
      require("../Images/Projects/Github/5.jpg"),
    ],
    contentTitle: "Some of my projects that I've done while learning.",
    content: ["Javascript & React projects :"],
    links: [
      { name: "Bankist App", link: "https://github.com/marcinzygan/BankApp" },
      {
        name: "Meme Generator",
        link: "https://github.com/marcinzygan/React-meme-generator",
      },
      {
        name: "Tenzies Game ",
        link: "https://github.com/marcinzygan/React-Tenzies",
      },
      {
        name: "Travel Journal",
        link: "https://github.com/marcinzygan/React-travel-Journal",
      },
      {
        name: "Buisness Card",
        link: "https://github.com/marcinzygan/React-BusinessCard",
      },
      {
        name: "Task Organizer",
        link: "https://github.com/marcinzygan/JavaScript-Task-Organizer",
      },
      {
        name: "Color Flipper",
        link: "https://github.com/marcinzygan/JavaScript-Color-Flipper",
      },
      {
        name: "Countdown Timer",
        link: "https://github.com/marcinzygan/JavaScript-Cuntdown-Timer",
      },
      {
        name: "Guess Number Game",
        link: "https://github.com/marcinzygan/JavaScript-Guess-My-Number",
      },
      {
        name: "Bankist Website",
        link: "https://github.com/marcinzygan/JavaScript-Bankist-Website",
      },
    ],
  },
];
